import { render, staticRenderFns } from "./GibusLogo.vue?vue&type=template&id=c3b56f00&scoped=true&"
var script = {}
import style0 from "./GibusLogo.vue?vue&type=style&index=0&id=c3b56f00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b56f00",
  null
  
)

export default component.exports